import React, { useState } from 'react';
import Table from "../../components/Table";
import StateContext from '../../helpers/ContextState';
import Config from '../../helpers/Config';

const App = (props) => {
  const context = React.useContext(StateContext);
  const [param] = useState({});

  const tds = [
    {
      label: "Usuario",
      value: "usuario",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "ID o NIT",
      value: "nro_documento",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "Evento",
      value: "evento",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "Valor Anterior",
      value: "valor_anterior",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "Valor Nuevo",
      value: "valor_nuevo",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "Realizado Por",
      value: "funcionario",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "Fecha Cambio",
      value: "fecha",
      className: "text-center",
      classNameHeader: "col text-center",
    },
    {
      label: "Hora",
      value: "hora",
      className: "text-center",
      classNameHeader: "col text-center",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <Table
            customFiltersTrazabilidad={true}
            toExport={Config.ConfigApirest + 'Excel/Users/ListadoTrazabilidadUsuariosExcel/token:' + context.user.token}
            toPDF={Config.ConfigApirest + 'PDF/Users/ListadoTrazabilidadUsuarios/' + context.user.token}
            td={tds}
            modelo="Users"
            metodo="GetTrazabilidadUsuarios"
            limit="10"
            params={param}
          />
        </div>
      </div>
    </div>
  );
};

export default App;
